import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/goods.vue'
createPage(Page)